export default __webpack_public_path__ + "static/img9v-0b2330538003e2d090ea8738ccd7c72b.jpg";